import React, { useState, useEffect, useRef } from 'react';
import emailjs from 'emailjs-com';
import './App.css';

// Import placeholder images (in a real project, you would use actual images)
const office1 = "https://images.unsplash.com/photo-1560472355-536de3962603?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80";
const office2 = "https://images.unsplash.com/photo-1497366754035-f200968a6e72?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80";
const team1 = "https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80";
const team2 = "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80";
const services = "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80";

function App() {
  const [activeService, setActiveService] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [activeTab, setActiveTab] = useState('home');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [formStatus, setFormStatus] = useState({
    submitting: false,
    submitted: false,
    error: null
  });
  
  // Create refs for each section
  const homeRef = useRef(null);
  const servicesRef = useRef(null);
  const aboutRef = useRef(null);
  const contactRef = useRef(null);
  const formRef = useRef(null);

  const servicesData = [
    {
      title: "Bookkeeping Services",
      description: "Full bookkeeping services or oversight, at your premises if required."
    },
    {
      title: "VAT Services",
      description: "Calculation and submission of bi-monthly or monthly VAT Returns."
    },
    {
      title: "Monthly Management Statements",
      description: "Monthly compilation of income statements and balance sheets with evaluations if required."
    },
    {
      title: "Corporate Tax",
      description: "Calculation and submission of bi-annual provisional tax returns and annual Income Tax returns."
    },
    {
      title: "Individual Tax",
      description: "Calculation and submission of bi-annual provisional tax returns and annual Income Tax returns."
    },
    {
      title: "Secretarial & Statutory Services",
      description: "New company registrations, amendments to companies/CC's, and other company-related matters."
    },
    {
      title: "Registrations",
      description: "Income Tax, PAYE and VAT registrations handled efficiently."
    },
    {
      title: "Tax Consulting",
      description: "Consultation on beneficial company structures and any required tax advice."
    },
    {
      title: "SARS Queries",
      description: "Follow up and resolution of SARS related queries on your behalf."
    },
    {
      title: "Financial Statements",
      description: "Compilation of Financial statements for tax submissions, loan applications or any other purpose."
    },
    {
      title: "Additional Services",
      description: "Dividends tax, Tender document compilation, Tax Clearances and more."
    }
  ];

  const sliderImages = [
    {
      url: office1,
      title: "Modern Office Facilities",
      description: "Our state-of-the-art office provides a comfortable environment for client consultations"
    },
    {
      url: team2,
      title: "Expert Accounting Team",
      description: "Our qualified professionals are ready to handle all your accounting needs"
    },
    {
      url: services,
      title: "Comprehensive Services",
      description: "We offer a full range of accounting and business consulting services"
    },
    {
      url: office2,
      title: "Client-Centered Approach",
      description: "We focus on building long-term relationships with our clients"
    },
    {
      url: team1,
      title: "Years of Experience",
      description: "Our team brings decades of combined accounting experience"
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === sliderImages.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? sliderImages.length - 1 : prev - 1));
  };

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    setFormStatus({ submitting: true, submitted: false, error: null });

    // EmailJS configuration - Replace with your actual EmailJS credentials
    const serviceID = 'service_6qr3jf6'; // Replace with your EmailJS service ID
    const templateID = 'template_rybpz4q'; // Replace with your EmailJS template ID
    const userID = 'tAOKUrQMF18C2vXJ1'; // Replace with your EmailJS user ID

    emailjs.send(serviceID, templateID, {
      from_name: formData.name,
      from_email: formData.email,
      from_phone: formData.phone,
      from_subject: formData.subject,
      message: formData.message,
      to_name: 'NMV Accounting',
      to_email: 'info@nmvaccounting.co.za', // Add recipient email
      reply_to: formData.email
    }, userID)
    .then((result) => {
      console.log('Email successfully sent!', result.text);
      setFormStatus({ submitting: false, submitted: true, error: null });
      setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
      
      // Reset form status after 5 seconds
      setTimeout(() => {
        setFormStatus({ submitting: false, submitted: false, error: null });
      }, 5000);
    }, (error) => {
      console.log('Failed to send email:', error.text);
      setFormStatus({ 
        submitting: false, 
        submitted: false, 
        error: 'Failed to send message. Please try again later or contact us directly.' 
      });
    });


    
  };

  // Auto-advance slides
  useEffect(() => {
    const timer = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  // Handle scroll to update active tab - FIXED FOR MOBILE
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 100;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      
      // Check if we're at the bottom of the page
      if (scrollPosition + windowHeight >= documentHeight - 50) {
        setActiveTab('contact');
        return;
      }
      
      // Check which section is in view
      const sections = [
        { id: 'home', ref: homeRef },
        { id: 'services', ref: servicesRef },
        { id: 'about', ref: aboutRef },
        { id: 'contact', ref: contactRef }
      ];
      
      for (const section of sections) {
        const element = section.ref.current;
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetBottom = offsetTop + element.offsetHeight;
          
          if (scrollPosition >= offsetTop && scrollPosition < offsetBottom) {
            setActiveTab(section.id);
            break;
          }
        }
      }
    };

    // Use requestAnimationFrame for smoother scrolling performance on mobile
    let ticking = false;
    const scrollHandler = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', scrollHandler, { passive: true });
    // Initial check
    handleScroll();
    
    return () => window.removeEventListener('scroll', scrollHandler);
  }, []);

  // Handle click to set active tab
  const handleTabClick = (tab) => {
    setActiveTab(tab);
    // Smooth scroll to section
    setTimeout(() => {
      let element = null;
      switch(tab) {
        case 'home':
          element = homeRef.current;
          break;
        case 'services':
          element = servicesRef.current;
          break;
        case 'about':
          element = aboutRef.current;
          break;
        case 'contact':
          element = contactRef.current;
          break;
        default:
          element = homeRef.current;
      }
      
      if (element) {
        window.scrollTo({
          top: element.offsetTop - 100,
          behavior: 'smooth'
        });
      }
    }, 100);
  };

  return (
    <div className="App">
      {/* Header */}
      <header className="header">
        <div className="container">
          <h1>NMV Accounting & Business Consultants</h1>
          <nav>
            <ul>
              <li>
                <a 
                  href="#home" 
                  className={activeTab === 'home' ? 'active' : ''}
                  onClick={(e) => {
                    e.preventDefault();
                    handleTabClick('home');
                  }}
                >
                  Home
                </a>
              </li>
              <li>
                <a 
                  href="#services" 
                  className={activeTab === 'services' ? 'active' : ''}
                  onClick={(e) => {
                    e.preventDefault();
                    handleTabClick('services');
                  }}
                >
                  Services
                </a>
              </li>
              <li>
                <a 
                  href="#about" 
                  className={activeTab === 'about' ? 'active' : ''}
                  onClick={(e) => {
                    e.preventDefault();
                    handleTabClick('about');
                  }}
                >
                  About
                </a>
              </li>
              <li>
                <a 
                  href="#contact" 
                  className={activeTab === 'contact' ? 'active' : ''}
                  onClick={(e) => {
                    e.preventDefault();
                    handleTabClick('contact');
                  }}
                >
                  Contact
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </header>

      {/* Hero Section with Slider */}
      <section id="home" className="hero" ref={homeRef}>
        <div className="slider">
          {sliderImages.map((slide, index) => (
            <div 
              key={index} 
              className={index === currentSlide ? "slide active" : "slide"}
              style={{ backgroundImage: `url(${slide.url})` }}
            >
              <div className="slide-content">
                <h2>{slide.title}</h2>
                <p>{slide.description}</p>
              </div>
            </div>
          ))}
          <button className="slider-btn prev" onClick={prevSlide}>&#10094;</button>
          <button className="slider-btn next" onClick={nextSlide}>&#10095;</button>
          <div className="slider-dots">
            {sliderImages.map((_, index) => (
              <span 
                key={index} 
                className={index === currentSlide ? "dot active" : "dot"}
                onClick={() => setCurrentSlide(index)}
              ></span>
            ))}
          </div>
        </div>
        <div className="hero-content">
          <h2>Expert Accounting Services for Your Business</h2>
          <p>Do you need an accountant who works in your business, so you have more time to work on your business? You've definitely come to the right place.</p>
          <p>We offer peace of mind service with excellent bookkeepers and accountants at affordable prices. We strive to keep your business compliant, saving money, and moving forward.</p>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="services" ref={servicesRef}>
        <div className="container">
          <h2>Our Services</h2>
          <p className="section-intro">We offer a wide variety of quality bookkeeping, accounting and tax services to clients from small to medium-sized businesses across all industries.</p>
          
          <div className="services-grid">
            {servicesData.map((service, index) => (
              <div 
                key={index} 
                className="service-card"
                onMouseEnter={() => setActiveService(index)}
                onMouseLeave={() => setActiveService(null)}
              >
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about" ref={aboutRef}>
        <div className="container">
          <h2>Why Choose <span className="lime-highlight">NMV Accounting</span>?</h2>
          <div className="about-content">
            <div className="about-text">
              <p>At NMV Accounting and Business Consultants, we understand that every minute counts when you're running a business. That's why we provide comprehensive accounting solutions that integrate seamlessly with your operations.</p>
              <p>Our team of qualified professionals is dedicated to delivering accurate, timely financial services that help you make informed business decisions while ensuring full compliance with all regulatory requirements.</p>
              <ul>
                <li>Experienced, qualified accounting professionals</li>
                <li>Personalized service tailored to your business needs</li>
                <li>Proactive approach to tax planning and compliance</li>
                <li>Affordable pricing for businesses of all sizes</li>
                <li>On-premises services available when required</li>
              </ul>
            </div>
            <div className="about-image">
              <img src={team1} alt="NMV Accounting Team" />
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="contact" ref={contactRef}>
        <div className="container">
          <h2>Contact Us</h2>
          <div className="contact-content">
            <div className="contact-info">
              <h3>Get In Touch</h3>
              <p>Ready to focus more on your business while we handle your accounting needs? Reach out to us for a consultation.</p>
              
              <div className="address">
                <h4>Our Office</h4>
                <p>137 9TH Road</p>
                <p>The West End</p>
                <p>Midrand</p>
                <p>Gauteng</p>
                <p>South Africa</p>
              </div>
              
              <div className="contact-details">
                <p><strong>Email:</strong> info@nmvaccounting.co.za</p>
                <p><strong>Phone:</strong> 073 961 7856 / 064 093 8830</p>
                <p><strong>WhatsApp:</strong> 073 961 7856 </p>
                <p><strong>Hours:</strong> Monday-Friday: 8:30AM - 5:00PM</p>
              </div>
            </div>
            
            <form className="contact-form" ref={formRef} onSubmit={handleSubmit}>
              <input 
                type="text" 
                name="name"
                placeholder="Your Name" 
                value={formData.name}
                onChange={handleInputChange}
                required 
              />
              <input 
                type="email" 
                name="email"
                placeholder="Your Email" 
                value={formData.email}
                onChange={handleInputChange}
                required 
              />
              <input 
                type="tel" 
                name="phone"
                placeholder="Your Phone" 
                value={formData.phone}
                onChange={handleInputChange}
              />
               <input 
                type="text" 
                name="subject"
                placeholder="Subject" 
                value={formData.subject}
                onChange={handleInputChange}
                required 
              />
              <textarea 
                name="message"
                placeholder="How can we help you?" 
                rows="5" 
                value={formData.message}
                onChange={handleInputChange}
                required
              ></textarea>
              
              {formStatus.error && (
                <div className="form-error">{formStatus.error}</div>
              )}
              
              {formStatus.submitted ? (
                <div className="form-success">
                  Thank you for your message! We'll get back to you soon.
                </div>
              ) : (
                <button 
                  type="submit" 
                  disabled={formStatus.submitting}
                  className={formStatus.submitting ? 'submitting' : ''}
                >
                  {formStatus.submitting ? 'Sending...' : 'Send Message'}
                </button>
              )}
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <h3>NMV Accounting & Business Consultants</h3>
              <p>Your trusted partner for financial success</p>
              <div className="footer-address">
                <p>137 9TH Road</p>
                <p>The West End</p>
                <p>Midrand</p>
                <p>Gauteng</p>
                <p>South Africa</p>
              </div>
            </div>
            <div className="footer-links">
              <h4>Quick Links</h4>
              <ul>
                <li><a href="#home">Home</a></li>
                <li><a href="#services">Services</a></li>
                <li><a href="#about">About</a></li>
                <li><a href="#contact">Contact</a></li>
              </ul>
            </div>
            <div className="footer-services">
              <h4>Our Services</h4>
              <ul>
                <li>Bookkeeping</li>
                <li>Tax Services</li>
                <li>Financial Statements</li>
                <li>Business Consulting</li>
              </ul>
            </div>
            <div className="footer-contact">
              <h4>Contact Info</h4>
              <p>Email: info@nmvaccounting.co.za</p>
              <p>Phone: 073 961 7856 / 064 093 8830 </p>
              <p>WhatsApp: 073 961 7856 </p>
              <p>Hours: Mon-Fri: 8:30AM - 5:00PM</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} NMV Accounting and Business Consultants. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;